import InputField from "@/components/InputField";
import defaultValues from "@/constant/defaultValues";
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

const DAPFreight = (props) => {
  const { DAP_SERVICE_TYPE, CONTAINER_TYPE } = defaultValues;

  const {
    errors,
    styleError,
    selectedOceanType,
    handleOceanTypeChange,
    handleFocusOut,
    handlePortOfOriginChange,
    countries,
    selectedCountryFrom,
    handleCountryFromChange,
    handleOriginPortInputChange,
    portOfOriginList,
    selectedPortOfOrigin,
    validatePortInput,
    originLoader,
    formData,
    handleChange,
    selectedCbpp,
    handleCbppTypeChange,
  } = props;

  const [nocPlaceholder, setNocPlaceholder] = useState("No of Containers");
  const [nocRequired, setNocRequired] = useState(false);

  useEffect(() => {
    if (selectedOceanType) {
      if (
        selectedOceanType.value === "FCL" ||
        selectedOceanType.value === "DAG_GOODS"
      ) {
        setNocPlaceholder("No of Containers");
        setNocRequired(true);
      } else if (selectedOceanType.value === "LCL") {
        setNocPlaceholder("No of Containers");
        setNocRequired(false);
      } else if (selectedOceanType.value === "Ro-Ro") {
        setNocPlaceholder("No of Units");
        setNocRequired(false);
      } else if (selectedOceanType.value === "Project_Cargo") {
        setNocPlaceholder("No of pieces");
        setNocRequired(true);
      }
    }
  }, [selectedOceanType]);

  return (
    <>
      <div className="col-sm-6">
        <div className="input-group">
          <label className="form-label required">Cargo Type</label>
          <div className="input-pad">
            <Select
              name="ocean_type"
              options={DAP_SERVICE_TYPE}
              value={selectedOceanType}
              onChange={handleOceanTypeChange}
              placeholder="Select cargo type"
              className="dd-pad"
              noOptionsMessage={() => "No Cargo Type Found"}
              onBlur={handleFocusOut}
            />
            {errors.ocean_type && (
              <span className="company-required" style={styleError}>
                {errors.ocean_type}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label required">Country</label>
          <div className="input-pad">
            <Select
              name="country_from"
              options={countries}
              value={selectedCountryFrom}
              onChange={handleCountryFromChange}
              placeholder="Select country"
              className="dd-pad"
              onBlur={handleFocusOut}
              noOptionsMessage={() => "No Country Found"}
            />
            {errors.country_from && (
              <span className="company-required" style={styleError}>
                {errors.country_from}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6">
        <div className="input-group">
          <label className="form-label required">Port</label>
          <div className="input-pad">
            <CreatableSelect
              name="port_of_origin"
              onChange={handlePortOfOriginChange}
              onInputChange={handleOriginPortInputChange}
              options={portOfOriginList}
              value={selectedPortOfOrigin}
              classNamePrefix={"creatable_react_select"}
              placeholder={`Enter port`}
              formatCreateLabel={(inputValue) => {
                const validationError = validatePortInput(inputValue);
                if (
                  validationError ||
                  validatePortInput(inputValue) ||
                  isEmpty(inputValue)
                ) {
                  return;
                }
                return `Create "${inputValue}"`;
              }}
              isValidNewOption={(inputValue) => {
                const validationError = validatePortInput(inputValue);
                return validationError === null;
              }}
              isLoading={originLoader}
            />

            {errors.port_of_origin && (
              <span className="company-required" style={styleError}>
                {errors.port_of_origin}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6 ">
        <div className="input-group">
          {
            selectedOceanType && selectedOceanType.value == "Ro-Ro" ? <label className="form-label required">Commodity / Product</label> : <label className="form-label required">Commodity</label>
          }
          
          <div className="input-pad">
            <InputField
              type="text"
              name="commodity"
              value={formData.commodity}
              // className="form-control"
              autoComplete="off"
              placeholder={selectedOceanType && selectedOceanType.value == "Ro-Ro" ? "Enter commodity /  product *" : "Enter commodity *"}
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.commodity && (
              <span className="company-required" style={styleError}>
                {errors.commodity}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label">HS Code</label>
          <div className="input-pad">
            <InputField
              type="text"
              name="hs_code"
              value={formData.hs_code}
              // className="form-control"
              autoComplete="off"
              placeholder="Enter hs code"
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.hs_code && (
              <span className="company-required" style={styleError}>
                {errors.hs_code}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6 ">
        <div className="input-group">
          <label className={`form-label ${nocRequired ? 'required' : ''}`}>
            {nocPlaceholder}
          </label>
          <div className="input-pad">
            <InputField
              type="text"
              name="no_of_containers"
              value={formData.no_of_containers}
              // className="form-control"
              autoComplete="off"
              placeholder={nocPlaceholder}
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.no_of_containers && (
              <span className="company-required" style={styleError}>
                {errors.no_of_containers}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="col-sm-6 ">
        <div className="input-group">
          {selectedOceanType && selectedOceanType.value == "FCL" && (
            <label className="form-label required">
              Type of container
            </label>
          )}

          {selectedOceanType &&
            (selectedOceanType.value == "LCL" ||
              selectedOceanType.value == "DAG_GOODS") && (
              <label className="form-label required">
                Type of Packaging
              </label>
            )}
            {selectedOceanType &&
            (selectedOceanType.value == "Project_Cargo") && (
              <label className="form-label">
                Type of Packaging
              </label>
            )}
          <div className="input-pad">
            {selectedOceanType && selectedOceanType.value == "FCL" && (
              <Select
                name="cbpp"
                options={CONTAINER_TYPE}
                value={selectedCbpp}
                onChange={handleCbppTypeChange}
                placeholder="Select type of container"
                className="dd-pad"
                noOptionsMessage={() => "No container Found"}
                onBlur={handleFocusOut}
              />
            )}
            {selectedOceanType &&
              (selectedOceanType.value == "LCL" ||
                selectedOceanType.value == "DAG_GOODS" || selectedOceanType.value == "Project_Cargo") && (
                <InputField
                  type="text"
                  name="cbpp"
                  value={formData.cbpp}
                  // className="form-control"
                  autoComplete="off"
                  placeholder="Enter type of Packaging"
                  onChange={handleChange}
                  onBlur={handleFocusOut}
                />
              )}

            {errors.cbpp && (
              <span className="company-required" style={styleError}>
                {errors.cbpp}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label">Total Weight (KG)</label>
          <div className="input-pad">
            <InputField
              type="text"
              name="total_weight"
              value={formData.total_weight}
              // className="form-control"
              autoComplete="off"
              placeholder="Enter Total Weight (KG)"
              onChange={handleChange}
              onBlur={handleFocusOut}
            />

            {errors.total_weight && (
              <span className="company-required" style={styleError}>
                {errors.total_weight}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-6 ">
        <div className="input-group">
          <label className="form-label required">Delivery Address</label>
          <div className="input-pad">
            <InputField
              type="text"
              name="delivery_address"
              value={formData.delivery_address}
              // className="form-control"
              autoComplete="off"
              placeholder="Enter delivery address"
              onChange={handleChange}
              onBlur={handleFocusOut}
            />
            {errors.delivery_address && (
              <span className="company-required" style={styleError}>
                {errors.delivery_address}
              </span>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DAPFreight;
